define('webshopCategoriesDetailBodyImagesView',[
  'app',
  'module',
  'backbone',
  'marionette',
  'underscore',
  'webshopCategoriesDetailBodyImagesTypeView',
  'entities/webshop/categories'
], function (
  App,
  Module,
  Backbone,
  Marionette,
  _,
  TypeView
) {
  'use strict';

  Module.exports = Marionette.CollectionView.extend({
    className: 'webshop-categories-detail-body-images-view',
    childView: TypeView,

    childViewOptions: function () {
      return {
        category: this.model
      };
    },

    initialize: function () {
      this.collection = new Backbone.Collection();
      this.fetch();
    },

    fetch: function () {
      App.request('webshop.categories.images.types').done(_.bind(function (types) {
        this.collection.reset(types);
      }, this));
    }
  });
});
